'use strict';

class ConfiguratorImageChanger {

    constructor() {
        this.configuratorImagesContainer = $('#configurator-images-container');
    }

    setUpListeners() {
        $('.color-changes input')
            .each((_, element) => {
                const $element = $(element);
                if (!$element.prop('checked')) {
                    return;
                }
                const colorId = $element.val();
                this.showImage(colorId);
            })
            .on('change', event => {
                const sectionId = $(event.target).data('sectionid');
                const colorId = $(event.target).val();

                this.hideAllImagesInSection(sectionId);
                this.showImage(colorId);
            })
            .on('click', event => {
                const colorId = $(event.target).val();

                if ($(event.target).next().hasClass('active')) {
                    this.hideImage(colorId)
                }
            });
    }

    showImage(colorId) {
        this.configuratorImagesContainer.find('[data-colorid="' + colorId + '"]').show();
    }

    hideImage(colorId) {
        this.configuratorImagesContainer.find('[data-colorid="' + colorId + '"]').hide();
    }

    hideAllImagesInSection(sectionId) {
        this.configuratorImagesContainer
            .find(`[data-colorsectionid=${sectionId}] .configuration-element`)
            .hide();
    }

}

export default ConfiguratorImageChanger;



// WEBPACK FOOTER //
// ./assets/js/utils/configurator-image-changer.js